import React from "react";
import Link from "components/ExtendLink";


const Heading = props => {

  return (
    <>
      {props.tab && props.tab == "3" ?
        (<div className="col-12">
          <span className={`mb-2 ${props.mainbutton}`}>
            <Link tag={Link} to="/create/extreme-reading">
              <a
                target="_blank"
                className="text-white ml-auto btn btn-info btn-rounded btn-fw"
              >
                Create a New Event Expectation Range
              </a>
            </Link>
          </span>
        </div>)
        : (<div className="col-12">
          <div className="page-header">
            <h3 className="page-title">
              {props.children}
              {props.title} {!props.isCareProvider ? "For Your Own Self" : ""}
            </h3>
            <nav aria-label="breadcrumb">
              <ul className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  <span />

                  <i className="mdi mdi-alert-circle-outline icon-sm text-danger align-middle" />
                </li>
              </ul>
            </nav>
          </div>
          <span
            className={`align-items-center purchase-popup mb-2 ${props.backbutton}`}
          >
            <Link
              to="/expectations"
              className="text-white mr-auto btn btn-gradient-dark btn-icon-text"
            >
              <i className="mdi mdi-arrow-left btn-icon-prepend" />
              Back
            </Link>
          </span>
          <span
            className={`mb-2 ${props.mainbutton}`}
          >
            <a
              target="_blank"
              onClick={props.toggleModal}
              className="text-white btn btn-info btn-rounded btn-fw"
            >
              Create a New Expectation
            </a>
          </span>
        </div>)
      }
    </>
  )
};

export default Heading;
